module.exports = __webpack_public_path__ + "static/img/d-data.0bf4dfba.png";